export default __webpack_public_path__ + "static/img58v-4e6937fc59d3172e8264070352387a37.jpg";